import { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import Loading from "../ui/Loading";

export default function TenorModal({
  children,
  passShowTenorModal,
  passTenorId,
  passTenorSlug,
  passTenorPreviewUrl,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const [gifs, setGifs] = useState([]);
  const [gifsPage, setGifsPage] = useState(1);
  const [gifsQuery, setGifsQuery] = useState();
  const [limit, setLimit] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);
  const [offset, setOffset] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: true });

  const closeModal = () => {
    passShowTenorModal(false);
    // history.replaceState({}, document.title, props.returnHref);
  };

  // bouton retour
  addEventListener("popstate", (event) => {
    closeModal();
  });

  // bouton echap
  // addEventListener("keydown", (event) => {
  //   if (event.key === "Escape") {
  //     closeModal();
  //   }
  // });

  const fetchGifs = () => {
    var tenorUrl =
      "https://tenor.googleapis.com/v2/featured?media_filter=webp,png&locale=fr_FR" +
      "&limit=" +
      limit +
      "&offset=" +
      offset +
      "";

    if (gifsQuery) {
      tenorUrl =
        "https://tenor.googleapis.com/v2/search?media_filter=webp,png&locale=fr_FR" +
        "&limit=" +
        limit +
        "&pos=" +
        offset +
        "&q=" +
        encodeURIComponent(gifsQuery);
    }

    var bodyFormData = new FormData();
    bodyFormData.append("url", tenorUrl);
    bodyFormData.append("token", props.userTk);

    axios
      .post("https://api.choualbox.com/api/tenor", bodyFormData)
      .then((response) => {
        if (response?.data?.data?.results) {
          if (gifsPage === 1) {
            console.log(response.data.data.results);
            setGifs(Array.from(response.data.data.results));
            setOffset(response.data.data.next);
          } else {
            setGifs([...gifs, ...response.data.data.results]);
            setOffset(response.data.data.next);
          }
        } else {
          toast(response.data.message, {
            type: "error",
          });
        }

        setLoading(false);
        setLoadingMore(false);
      });
  };

  const gifSearchTypeKeyboard = (query) => {
    // wait 0.5 seconds before searching
    setGifsQuery(query);
    setGifs([]);
    setGifsPage(1);
    setOffset(0);
  };

  useEffect(() => {
    fetchGifs();
  }, [gifsPage, gifsQuery]);

  useEffect(() => {
    fetchGifs();
    setGifs(false);
    setGifsPage(1);
    setGifsQuery(false);
  }, []);

  const _handleLoadMore = () => {
    setGifsPage(gifsPage + 1);
    setLoadingMore(true);
  };

  // useEffect(() => {
  //   if (inView && !loadingMore) {
  //     _handleLoadMore();
  //   }
  // }, [inView]);

  return (
    <div
      className="bg-black/75 left-0 right-0 top-0 bottom-0 fixed z-50"
      onClick={() => {
        closeModal();
      }}
    >
      <div className="flex items-end sm:items-center justify-center h-full pt-12 sm:py-20 sm:max-w-lg sm:mx-auto">
        <div
          className="Tenormodal-content flex flex-col bg-base-100 rounded-t-lg sm:rounded w-full sm:w-lg p-2 h-full"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="flex flex-row items-center pb-2 border-b border-base-content/10">
            <button
              onClick={() => {
                closeModal();
              }}
              className="closeTenormodal ml-2 mr-4 text-base-content/50"
            >
              <MdClose className="w-6 h-6" />
            </button>
            <div className="text-base-content text-lg font-bold">
              Ajouter un GIF
            </div>
          </div>

          <div className="pt-4 flex grow flex-col">
            <div>
              <input
                type="text"
                placeholder="Recherche sur Tenor"
                className="input input-bordered w-full text-base-content"
                onChange={(event) => {
                  gifSearchTypeKeyboard(event.target.value);
                }}
              />
            </div>
            <div className="relative flex-1 pt-2">
              <div className="pt-2 absolute left-0 top-0 right-0 bottom-0 overflow-y-auto text-base-content hide-scrollbar flex flex-row flex-wrap">
                {gifs ? (
                  gifs.map((gif) => {
                    // Console log to inspect gif object
                    // console.log("gif object:", gif);

                    // Check if media and webp exist
                    if (!gif.media_formats || !gif.media_formats.webp) {
                      console.error(
                        "gif.media or gif.media.webp is missing:",
                        gif
                      );
                      return null;
                    }

                    return (
                      <div key={gif.id} className="w-1/2">
                        <picture
                          onClick={() => {
                            console.log("gif", gif);
                            passTenorId(gif.id);
                            passTenorSlug(gif.itemurl);
                            passTenorPreviewUrl(gif.media_formats.webp.url);
                            passShowTenorModal(false);
                          }}
                        >
                          <source
                            type="image/webp"
                            srcSet={gif.media_formats.webp.url}
                            onError={(e) =>
                              console.error("Error loading webp:", e)
                            }
                          />
                          <img
                            className="aspect-square object-contain cursor-pointer border border-base-100 bg-base-200"
                            src={gif.media_formats.webp.url}
                            alt={gif.media_formats.content_description}
                            onError={(e) =>
                              console.error("Error loading img:", e)
                            }
                          />
                        </picture>
                      </div>
                    );
                  })
                ) : (
                  <span className="loading-dots text-base-content"></span>
                )}
                {gifs.length > 0 && gifs.length >= limit && gifsQuery ? (
                  <div className="mt-4 w-full p-2 sm:p-0">
                    <button
                      onClick={() => _handleLoadMore()}
                      className={`btn btn-ghost w-full ${
                        gifs.length > 0 &&
                        gifs.length >= limit &&
                        !loading &&
                        gifsQuery
                          ? "opacity-100"
                          : "opacity-50 btn-disabled"
                      }`}
                      disabled={loadingMore}
                    >
                      {loadingMore ? (
                        <Loading />
                      ) : (
                        <div ref={ref}>Charger plus</div>
                      )}
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
